import * as coreTypes from './types'
/**
 * Data
 */
const loadData = () => ({
  type: coreTypes.LOAD_DATA
})

/**
 * Snackbar
 */

const closeSnackbar = () => ({
  type: coreTypes.CLOSE_SNACKBAR
})

/**
 * Auth / profile
 */

export interface IProfilePayload {
  name: string
  given_name: string
  email: string
}

export interface IProfileAction {
  type: string
  payload: IProfilePayload
}

const authSuccess = (payload: IProfilePayload) => ({
  type: coreTypes.AUTH_SUCCESS,
  payload
})

const logOut = () => ({
  type: coreTypes.LOGOUT
})

const setAgentBusinessUnit = (unit: {id: number, name: string}) => 
  ({
    type: coreTypes.SET_AGENT_BUSINESS_UNIT,
    payload: unit
  })


export { loadData, closeSnackbar, authSuccess, logOut, setAgentBusinessUnit }



// WEBPACK FOOTER //
// ./src/core/duck/actions.ts